import React, { Component } from 'react';
import './Groups.css';

class Groups extends Component {
  render() {
    if (this.props.data) {
      let groups = this.props.data.map(group => {
        return (
          <tr>
            <td>{group.id}</td>
            <td>{group.displayName}</td>
            {group.members && group.members.length > 0 ? (
              <td rowSpan={`${group.members ? group.members.length : 1}`}>
                {group.members.map(member => {
                  return (
                    <div>{`${member.type ? member.type : 'NA'} : ${
                      member.value ? member.value : 'NA'
                    }`}</div>
                  );
                })}
              </td>
            ) : (
              <td>N/A</td>
            )}
            <td>
              {new Date(group.meta.created).toLocaleDateString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td>Id</td>
              <td>Name</td>
              <td>Members</td>
              <td>Created Date</td>
            </tr>
          </thead>
          <tbody>{groups}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default Groups;
